/** @jsxImportSource @emotion/react */

import React, { useRef } from 'react';
import PageTemplate from '@page/iyagigo/page-template';
import SpeakingHome from '@component/iyagigo/speaking/speaking-home';
import Scroll from '@component/common/scroll';
import * as color from '@constant/color';

const SpeakingHomePage: React.FC<any> = () => {
  // 기록 탭 무한스크롤이 감시할 스크롤 컨테이너. 스크롤은 여기가 쥐고 있어 아래로 내려 준다.
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <PageTemplate title='AI 말하기' mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Scroll direction='y' height={`calc(100% - 10px)`} containerRef={scrollContainerRef}>
        <SpeakingHome scrollContainerRef={scrollContainerRef} />
      </Scroll>
    </PageTemplate>
  );
};

export default SpeakingHomePage;
